var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrivingMiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.667,
    cy: 31.5,
    r: 30.5,
    fill: "#fff",
    stroke: "#3C3C3C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#driving-miles_svg__clip0_23940_40104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.267 39.21a.905.905 0 00-.905.904v2.118a.906.906 0 00.905.905h1.148a.906.906 0 00.905-.905v-2.117a.906.906 0 00-.905-.906h-1.148zM42.487 43.207h-1.148a.977.977 0 01-.976-.975v-2.117a.976.976 0 01.976-.976h1.148a.976.976 0 01.975.976v2.117a.977.977 0 01-.975.975z",
    fill: "#303133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.725 41.512H21.96c-.9 0-1.632-.53-1.632-1.182v-3.801l.981-1.033h21.258l.79 1.035v3.799c0 .652-.731 1.182-1.63 1.182z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.474 37.397H21.421l-.214-3.28.136-.336.792-1.947h19.483l1.07 2.21-.214 3.353z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.652 34.052l-.157 2.465h-4.632v-1.832l4.658-.905.131.272zM25.96 34.685v1.832H21.4l-.157-2.395.133-.328 4.586.892z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5 32.397H22.251l2.053-6.844a1.374 1.374 0 011.309-.983l12.748-.122a1.38 1.38 0 011.349 1.034l1.79 6.915z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.018 31.75l-16.288-.194a.13.13 0 01-.106-.054.133.133 0 01-.018-.117l1.561-4.872a.131.131 0 01.126-.092h13.1a.13.13 0 01.126.092l1.626 5.065a.131.131 0 01-.127.172z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.264 32.256h-2.888v-.635a.775.775 0 01.774-.774h2.114v1.409zM44.378 32.256H41.49v-1.409h2.114a.774.774 0 01.774.774v.635z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.038 42.15L4.922 47.22l.06.168 14.116-5.072-.06-.166zM44.626 42.15l-.06.167 14.117 5.07.06-.167-14.117-5.07z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.661 45.827h-.845v-1.091h.845v1.09zm0-2.183h-.845v-1.091h.845v1.091zM32.661 50.348h-.845v-1.091h.845v1.09zm0-2.183h-.845v-1.091h.845v1.091z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.851 20.834a4.192 4.192 0 100-8.384 4.192 4.192 0 000 8.384z",
    fill: "#E95832"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#driving-miles_svg__clip1_23940_40104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.114 15.729l-1.709 1.708-.776-.777",
    stroke: "#fff",
    strokeWidth: 0.466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "driving-miles_svg__clip0_23940_40104"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4.922 12.049)",
    d: "M0 0h53.807v38.294H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "driving-miles_svg__clip1_23940_40104"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(30.008 14.797)",
    d: "M0 0h3.727v3.727H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/driving-miles.d1da616a.svg";
export { SvgDrivingMiles as ReactComponent };